import {api} from '~/shared/services/bffService';
import {retryApiRequest} from '~/shared/services/apiService/apiServiceUtils';
import {IMoneycardsRes} from '~/shared/services/bffService/api/interfaces/responses';

import {makeThunkAsyncActionCreator} from '../../redux-toolbelt';
import {selectUserData} from '../selectors.index';

import {selectMoneyCards, selectMoneyCardsLoaded} from './moneyCardsSelectors';

// Consumers that mount in the same tick (the header's action menu and the page under it) share
// the request that is already in flight, since the store is only updated once it resolves
let pendingRequest: Promise<IMoneycardsRes> | null = null;

const fetchMoneyCardsOnce = () => {
  if (!pendingRequest) {
    pendingRequest = retryApiRequest(() => api.fetchMoneycards()).finally(() => {
      pendingRequest = null;
    });
  }

  return pendingRequest;
};

export interface GetMoneyCardsIfNeededPayload {
  force?: boolean;
}

export const getMoneyCardsIfNeeded = makeThunkAsyncActionCreator<GetMoneyCardsIfNeededPayload, IMoneycardsRes>(
  'getMoneyCardsIfNeeded',
  async (payload, {store}) => {
    const state = store.getState();
    const currentValue = selectMoneyCards(state);
    const user = selectUserData(state);

    // Fetched once per visit, so every consumer after the first one is served by the store.
    // `force` is for the retry flows, which must hit the api even when the cards were already fetched.
    if (!user || (selectMoneyCardsLoaded(state) && !payload?.force)) {
      return currentValue;
    }

    // On 401 the error object is passed forward, the 401 handling taking place outside the thunk.
    // The store must not depend on the auth service, which imports the store back.
    return fetchMoneyCardsOnce();
  },
);
